import api from "api";
import { APIBaseOil, APIBaseOilInput } from "api/formulations";
import { computed } from "mobx";
import {
  ExtendedModel,
  model,
  modelFlow,
  prop,
  _async,
  _await,
} from "mobx-keystone";
import DirtyableWithId from "./DirtyableWithId";

@model("collab/BaseOil")
class BaseOil extends ExtendedModel(DirtyableWithId, {
  rcode: prop<string>(""),
  description: prop<string>(""),
  crdStatus: prop<string>(""),
}) {
  _prevId: number = 0;

  onInit() {
    this.updatePrevId();
  }

  updatePrevId() {
    this._prevId = this.id;
  }

  @computed
  get asAPI(): APIBaseOilInput {
    return {
      rcode: this.rcode,
      description: this.description,
      crdStatus: this.crdStatus,
    };
  }

  @modelFlow
  save = _async(function* (this: BaseOil) {
    if (!this.isDirty) {
      return;
    }

    let response: APIBaseOil;
    try {
      response = yield* _await(api.formulations.baseOilCreate(this.asAPI));
    } catch (e) {
      console.error(e);
      throw e;
    }

    this.update(response);
  });
}

export default BaseOil;
